/* eslint-disable prettier/prettier */
import styled, { DefaultTheme } from 'styled-components';
import {
  IBButtonProps,
  ButtonThemeVariant,
  variants,
  Sizes,
  sizes
} from './Button.types';

type ThemedProps = {
  theme: DefaultTheme;
} & IBButtonProps;

const getButtonVariantProp = (prop: keyof ButtonThemeVariant) => ({
  theme,
  colorType = variants.PRIMARY
}: ThemedProps) => {
  return theme.button[colorType][prop];
};

const getHeighBySize = (size: Sizes): string => {
  switch (size) {
    case sizes.LARGE:
      return '48px';
    case sizes.REGULAR:
      return '36px';
    case sizes.SMALL:
      return '24px';
    default:
      return '36px';
  }
};

const getWidthBySize = (size: Sizes): string => {
  switch (size) {
    case sizes.LARGE:
      return '139px';
    case sizes.SMALL:
      return '90px';
    case sizes.REGULAR:
    default:
      return '125px';
  }
};

const getFontBySize = (size: Sizes): string => {
  switch (size) {
    case sizes.LARGE:
      return '16px';
    case sizes.SMALL:
      return '12px';
    case sizes.REGULAR:
    default:
      return '12px';
  }
};

const StyledButton = styled.button<IBButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${getButtonVariantProp('background')};
  border: ${getButtonVariantProp('border')};
  border-radius: 0;
  height: ${({ size, height }) =>
    height ? `${height}px` : getHeighBySize(size)};
  min-width: ${({ size, width }) =>
    width ? `${width}px` : getWidthBySize(size)};
  color: ${getButtonVariantProp('color')};
  font-style: normal;
  font-weight: 600;
  font-size: ${({ size }) => getFontBySize(size)};
  opacity: ${({ disabled }) => (disabled ? '30%' : 1)};
  line-height: 24px;
  padding: 0 16px;
  text-align: center;
  user-select: none;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.2s;

  .spinner {
    width: 20px;
    height: 20px;
    margin-right: 16px;
  }

  &:hover:not(:disabled):not(.button--disabled):not(:active) {
    background-color: ${getButtonVariantProp('backgroundHover')};
    color: ${getButtonVariantProp('colorHover')};
    border: 1px solid ${getButtonVariantProp('borderColorHover')};
    .spinner {
      border-top: 2px solid ${getButtonVariantProp('spinnerColorHover')};
      border-right: 2px solid ${getButtonVariantProp('spinnerColorHover')};
      border-bottom: 2px solid ${getButtonVariantProp('spinnerColorHover')};
    }
  }
`;

StyledButton.defaultProps = {
  type: 'button'
};

export default StyledButton;
